import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const DescriptionBoxWrapper = styled.div`
  color: ${(props) => props.theme.textDark};
  transition: 600ms all;
  overflow: hidden;
  max-height: 300px;

  @media print {
    max-height: none !important;
  }
`;

export const DescriptionBox = styled.div`
  img {
    max-width: 500px;
    max-height: 300px;
    float: right;
    margin-left: 30px;
    vertical-align: middle;
  }

  ul {
    padding-left: 25px;

    li {
      margin: 5px 0;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 15px 0;
  }

  dt {
    margin: 15px 0 0;
  }

  dd,
  p {
    margin: 15px 0;
  }

  @media (${laptopMediumMax}) {
    img {
      display: none;
    }
  }

  @media print {
    max-height: none !important;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  bottom: -1px;
  width: 100%;
  height: 80px;
  padding: 50px 5px 5px 5px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 100%);

  .pp-btn {
    background-color: ${({ theme }) => theme.background};
    border: 1px solid ${({ theme }) => theme.keyline};
  }

  .pp-btn:hover {
    background-color: ${({ theme }) => theme.backgroundLightest};
  }

  .pp-btn p {
    color: ${({ theme }) => theme.textDark};
  }
`;
